import { api } from './api/client.js';
import { notifyUserDataUpdated } from './userDataEvents.js';

let cachedProfile = null;
let cachePromise = null;

/**
 * Shared in-flight cache for GET /company/profile.
 * Dedupes concurrent reads from AccessContext, RenewalGate, and Dashboard.
 */
export async function loadCompanyProfile(force = false) {
  if (!force && cachedProfile) return cachedProfile;
  if (!force && cachePromise) return cachePromise;

  cachePromise = api
    .get('/company/profile')
    .then((data) => {
      cachedProfile = data;
      return data;
    })
    .finally(() => {
      cachePromise = null;
    });

  return cachePromise;
}

/** Sync read of warm cache (no network). */
export function getCachedCompanyProfile() {
  return cachedProfile;
}

/** Clear after logout, profile edit, plan change, or role handoff. */
export function invalidateCompanyProfileCache() {
  cachedProfile = null;
  cachePromise = null;
  notifyUserDataUpdated();
}
